import { useAuth } from "contexts/auth/AuthContext";
import { normalizeUsersData } from "helpers/utils";
import { useMemo } from "react";
import { useAppSelector } from "store/store";

/**
 * `adminPanel.users.company.data`, filtered for display (see `normalizeUsersData` in helpers/utils).
 */
export function useNormalizedCompanyUsers() {
    const users = useAppSelector((state) => state.adminPanel.users.company.data);
    const { isAdminCrealo } = useAuth();
    return useMemo(() => normalizeUsersData(users ?? [], isAdminCrealo), [users, isAdminCrealo]);
}
